import Fields from './RegistrationOptionFields.json';

export default {
  [Fields.homeAddress1.id]: {
    id: Fields.homeAddress1.id,
    parentFieldId: Fields.homeAddress.id,
    regApiPath: ['homeAddress', 'address1'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.homeAddress2.id]: {
    id: Fields.homeAddress2.id,
    parentFieldId: Fields.homeAddress.id,
    regApiPath: ['homeAddress', 'address2'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.homeAddress3.id]: {
    id: Fields.homeAddress3.id,
    parentFieldId: Fields.homeAddress.id,
    regApiPath: ['homeAddress', 'address3'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.homeCity.id]: {
    id: Fields.homeCity.id,
    parentFieldId: Fields.homeAddress.id,
    regApiPath: ['homeAddress', 'city'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.homeCountry.id]: {
    id: Fields.homeCountry.id,
    parentFieldId: Fields.homeAddress.id,
    regApiPath: ['homeAddress', 'country'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.homeCountryCode.id]: {
    id: Fields.homeCountryCode.id,
    parentFieldId: Fields.homeAddress.id,
    regApiPath: ['homeAddress', 'countryCode'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.homeState.id]: {
    id: Fields.homeState.id,
    parentFieldId: Fields.homeAddress.id,
    regApiPath: ['homeAddress', 'state'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.homeStateCode.id]: {
    id: Fields.homeStateCode.id,
    parentFieldId: Fields.homeAddress.id,
    regApiPath: ['homeAddress', 'stateCode'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.homeZipPostalCode.id]: {
    id: Fields.homeZipPostalCode.id,
    parentFieldId: Fields.homeAddress.id,
    regApiPath: ['homeAddress', 'postalCode'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.workAddress1.id]: {
    id: Fields.workAddress1.id,
    parentFieldId: Fields.workAddress.id,
    regApiPath: ['workAddress', 'address1'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.workAddress2.id]: {
    id: Fields.workAddress2.id,
    parentFieldId: Fields.workAddress.id,
    regApiPath: ['workAddress', 'address2'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.workAddress3.id]: {
    id: Fields.workAddress3.id,
    parentFieldId: Fields.workAddress.id,
    regApiPath: ['workAddress', 'address3'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.workCity.id]: {
    id: Fields.workCity.id,
    parentFieldId: Fields.workAddress.id,
    regApiPath: ['workAddress', 'city'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.workCountry.id]: {
    id: Fields.workCountry.id,
    parentFieldId: Fields.workAddress.id,
    regApiPath: ['workAddress', 'country'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.workCountryCode.id]: {
    id: Fields.workCountryCode.id,
    parentFieldId: Fields.workAddress.id,
    regApiPath: ['workAddress', 'countryCode'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.workState.id]: {
    id: Fields.workState.id,
    parentFieldId: Fields.workAddress.id,
    regApiPath: ['workAddress', 'state'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.workStateCode.id]: {
    id: Fields.workStateCode.id,
    parentFieldId: Fields.workAddress.id,
    regApiPath: ['workAddress', 'stateCode'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.workZipPostalCode.id]: {
    id: Fields.workZipPostalCode.id,
    parentFieldId: Fields.workAddress.id,
    regApiPath: ['workAddress', 'postalCode'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.primaryAddress1.id]: {
    id: Fields.primaryAddress1.id,
    parentFieldId: Fields.primaryAddress.id,
    regApiPath: ['primaryAddress', 'address1'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.primaryAddress2.id]: {
    id: Fields.primaryAddress2.id,
    parentFieldId: Fields.primaryAddress.id,
    regApiPath: ['primaryAddress', 'address2'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.primaryAddress3.id]: {
    id: Fields.primaryAddress3.id,
    parentFieldId: Fields.primaryAddress.id,
    regApiPath: ['primaryAddress', 'address3'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.primaryCity.id]: {
    id: Fields.primaryCity.id,
    parentFieldId: Fields.primaryAddress.id,
    regApiPath: ['primaryAddress', 'city'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.primaryCountry.id]: {
    id: Fields.primaryCountry.id,
    parentFieldId: Fields.primaryAddress.id,
    regApiPath: ['primaryAddress', 'country'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.primaryCountryCode.id]: {
    id: Fields.primaryCountryCode.id,
    parentFieldId: Fields.primaryAddress.id,
    regApiPath: ['primaryAddress', 'countryCode'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.primaryState.id]: {
    id: Fields.primaryState.id,
    parentFieldId: Fields.primaryAddress.id,
    regApiPath: ['primaryAddress', 'state'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.primaryStateCode.id]: {
    id: Fields.primaryStateCode.id,
    parentFieldId: Fields.primaryAddress.id,
    regApiPath: ['primaryAddress', 'stateCode'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  },
  [Fields.primaryZipPostalCode.id]: {
    id: Fields.primaryZipPostalCode.id,
    parentFieldId: Fields.primaryAddress.id,
    regApiPath: ['primaryAddress', 'postalCode'],
    questionTypeInfo: {
      answerFormatType: 'General',
      questionType: 'OpenEndedText'
    }
  }
};
